import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HIDE_LOADER } from 'src/app/shared/interceptors/loader.interceptor';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}
  private apiRoot = '/api/private/';

  public getCDClient() {
    const context = new HttpContext().set(HIDE_LOADER, true);
    return this.http.get<any>(
      environment.contentdistribution.private.url + `${this.apiRoot}client/`,
      // eslint-disable-next-line prettier/prettier
      { context }
    );
  }
}
